// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ep-content__utility.utility-logo {
  display: flex;
  justify-content: flex-end;
  padding: 1rem;
}
.ep-content__utility.utility-logo > .utility-logo__img > img {
  width: 450px;
}
@media print {
  .ep-content__utility.utility-logo > .utility-logo__img > img {
    display: none;
  }
}
@media print {
  .ep-content__utility.utility-logo {
    display: none !important;
  }
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility {
  flex-grow: 1;
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links {
  display: flex;
  flex-grow: 1;
  justify-content: flex-end;
  padding: 1.5rem 0;
  list-style: none;
}
@media print {
  .ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links {
    display: none !important;
  }
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links > li {
  width: max-content;
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links > li > a {
  padding: 1rem;
  color: var(--ods-color-gray-60);
  font-weight: 600;
  font-size: 1.125rem;
  text-decoration: none;
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links > li > a:hover {
  color: var(--ods-color-gray-70);
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links > li > .activeLink {
  color: var(--ods-color-purple-60);
}
.ep-content__utility.utility-logo > .utility-logo__nav.nav-utility > .nav-utility__links > li > .activeLink:hover {
  color: var(--ods-color-purple-60);
}`, "",{"version":3,"sources":["webpack://./src/app/main/header/header.component.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,yBAAA;EACA,aAAA;AAAJ;AAIM;EACE,YAAA;AAFR;AAKM;EACE;IACE,aAAA;EAHR;AACF;AAOI;EAlBF;IAmBI,wBAAA;EAJJ;AACF;AAOM;EACE,YAAA;AALR;AAOQ;EACE,aAAA;EACA,YAAA;EACA,yBAAA;EACA,iBAAA;EACA,gBAAA;AALV;AAOU;EAPF;IAQI,wBAAA;EAJV;AACF;AAMU;EACE,kBAAA;AAJZ;AAMY;EACE,aAAA;EACA,+BAAA;EACA,gBAAA;EACA,mBAAA;EACA,qBAAA;AAJd;AAOY;EACE,+BAAA;AALd;AAQY;EACE,iCAAA;AANd;AASY;EACE,iCAAA;AAPd","sourcesContent":[".ep-content__utility {\n  &.utility-logo {\n    display: flex;\n    justify-content: flex-end;\n    padding: 1rem;\n\n    > .utility-logo__img {\n      // Logo SASS\n      > img {\n        width: 450px;\n      }\n\n      @media print {\n        > img {\n          display: none;\n        }\n      }\n    }\n\n    @media print {\n      display: none !important;\n    }\n\n    > .utility-logo__nav {\n      &.nav-utility {\n        flex-grow: 1;\n\n        > .nav-utility__links {\n          display: flex;\n          flex-grow: 1;\n          justify-content: flex-end;\n          padding: 1.5rem 0;\n          list-style: none;\n\n          @media print {\n            display: none !important;\n          }\n\n          > li {\n            width: max-content;\n\n            > a {\n              padding: 1rem;\n              color: var(--ods-color-gray-60);\n              font-weight: 600;\n              font-size: 1.125rem;\n              text-decoration: none;\n            }\n\n            > a:hover {\n              color: var(--ods-color-gray-70);\n            }\n\n            > .activeLink {\n              color: var(--ods-color-purple-60);\n            }\n\n            > .activeLink:hover {\n              color: var(--ods-color-purple-60);\n            }\n          }\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
